import SwiperLoading from './SwiperLoading';

export default SwiperLoading;
